import { render } from "./ChangeAppointmentSessionActivity.vue?vue&type=template&id=677ef922&scoped=true"
import script from "./ChangeAppointmentSessionActivity.vue?vue&type=script&lang=js"
export * from "./ChangeAppointmentSessionActivity.vue?vue&type=script&lang=js"

import "./ChangeAppointmentSessionActivity.vue?vue&type=style&index=0&id=677ef922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677ef922"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QCardActions,QSpace});qInstall(script, 'directives', {ClosePopup});
